import * as React from 'react';

import { useIsAdminCoachV2Enabled } from 'bundles/enterprise-admin-hooks/hooks/useFeatures';
import { AdminAuthNavigation } from 'bundles/enterprise-admin-navigation/components/AdminAuthNavigation';
import { useEnterpriseAdminContext } from 'bundles/enterprise-admin/EnterpriseAdminContext';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';

const WithGlobalNavAndStyleGuide = ({ children, ...props }: React.PropsWithChildren<{}>) => {
  const org = useThirdPartyOrganization();
  const { adminRoleType } = useEnterpriseAdminContext();
  const isAdminCoachV2Enabled = useIsAdminCoachV2Enabled();

  return (
    <div className="styleguide">
      <AdminAuthNavigation
        thirdPartyOrganization={org}
        adminRoleType={adminRoleType}
        isAdminCoachV2Enabled={isAdminCoachV2Enabled}
      />
      {React.isValidElement(children) ? React.cloneElement(children, props) : children}
    </div>
  );
};

export default WithGlobalNavAndStyleGuide;
